import { jsx as r, jsxs as l } from "react/jsx-runtime";
import t from "./index.es5663.js";
import h from "classnames";
import { CellAdditionalInfoWrapper as E } from "./index.es731.js";
import { BaseHeader as c } from "./index.es5578.js";
import { ColorIndicator as T } from "./index.es32.js";
import { BodyText as n } from "./index.es505.js";
const v = "data-grid-multiline-header", g = ({
  entityColor: a,
  colorIndicator: e,
  displayName: s,
  gridDensity: o,
  description: m,
  additionalInfo: d,
  title: p,
  testId: i = v,
  ...f
}) => {
  const u = h(t.root, t[o]);
  return /* @__PURE__ */ r(c, { displayName: s, ...f, testId: i, children: /* @__PURE__ */ l(
    "div",
    {
      className: u,
      "data-testid": i + "-multiline-container",
      role: "presentation",
      children: [
        (!!a || !!e) && /* @__PURE__ */ r(
          T,
          {
            entityColor: a,
            testId: (e == null ? void 0 : e.testId) || i + "-color-indicator",
            ...e
          }
        ),
        /* @__PURE__ */ l(
          "div",
          {
            className: t.info,
            "data-testid": i + "-info-container",
            role: "presentation",
            children: [
              /* @__PURE__ */ r(E, { ...d, children: /* @__PURE__ */ r(
                n,
                {
                  size: "default",
                  variant: "bold",
                  isEllipsis: !0,
                  "data-testid": i + "-title",
                  children: p || s
                }
              ) }),
              /* @__PURE__ */ r(
                n,
                {
                  size: "small",
                  variant: "regular",
                  isEllipsis: !0,
                  "data-testid": i + "-description",
                  children: m
                }
              )
            ]
          }
        )
      ]
    }
  ) });
};
export {
  v as DEFAULT_MULTILINE_HEADER_TESTID,
  g as MultilineHeader
};
//# sourceMappingURL=index.es638.js.map
